import httpService from "../Api/http.service";
import fetchService from "./getApidataStrapi";

/**
 * Normalize Strapi legal-page response to a consistent shape.
 * Supports both old (attributes) and new (document) response formats.
 */
export const normalizeStrapiLegalResponse = (data) => {
  const item = data?.data?.[0];
  if (!item) {
    return { title: '', revision_notice: '', description: '404 | This page could not be found.' };
  }
  // New format: document (legal-page collection)
  if (item.document) {
    return {
      title: item.document.title || item.document.displayTitle || '',
      revision_notice: item.document.revisionNote ?? '',
      description: item.document.content ?? '404 | This page could not be found.',
    };
  }
  // Old format: attributes (terms-policy collection)
  const attrs = item.attributes || {};
  return {
    title: attrs.title ?? '',
    revision_notice: attrs.revision_notice ?? '',
    description: attrs.description ?? '404 | This page could not be found.',
  };
};

const getDataFromStrapi = async (apiPath) => {
  try {
    return await fetchService(apiPath);
  } catch (err) {
    console.error('Strapi API Error:', err);
    throw err;
  }
};

const getPrivacyPolicy = async (apiPath) => {
  return getDataFromStrapi(apiPath);
};

const getTermsConditions = async (apiPath) => {
  return getDataFromStrapi(apiPath);
};

const getHipaaNotice = async (apiPath) => {
  return getDataFromStrapi(apiPath);
};

const getDisclosureStatement = (type = 'recur') => {
  const getPageId = () => {
    switch (type) {
      case 'recur':
        return '1899';
      case 'flex':
        return '2063';
      default:
        return '1899';
    };
  };

  const pageId = getPageId();
 
  return httpService({
    url: process.env.REACT_APP_WP_URL + `/pages/${pageId}`,
    method: "get",
  });
}

const getPaperlessNotice = () =>
  httpService({
    url: process.env.REACT_APP_WP_URL + "/pages/1836",
    method: "get",
  });

const wpServices = {
  getPrivacyPolicy,
  getTermsConditions,
  getHipaaNotice,
  getDisclosureStatement,
  getPaperlessNotice,
  getDataFromStrapi,
};

export default wpServices;
